import * as React from "react"
import { Link } from "react-router-dom"
import { Action, mk_widget, Widget } from "widgets-for-react"
import { ChangePasswordState, isChangePasswordState, LoginState } from "../state"
import { notifications } from '../notifications';
import { MinimalLoginWidgetData, update_state_with_route } from "../login";
import { LoginFlowStyle, LoginFlowClasses } from "./style.mod";
import { getClassName } from "../../utils/utils.mod";
import i18next = require("i18next");
import { ExtraUserInfo } from '../../portal_client';

function handleSubmit<a>(e: React.FormEvent<HTMLFormElement>, setState: (_: Action<LoginState<a, ExtraUserInfo>>) => void) {
  e.preventDefault();
  setState(s => isChangePasswordState(s) ? { ...s, status: "change password - sending" } : s);
}

export function change_password_form<a>(
  data: MinimalLoginWidgetData<a, ExtraUserInfo>,
  options?: { style?: LoginFlowStyle; key?: string }
) {
  return (s0: ChangePasswordState<ExtraUserInfo>, readonly: boolean, rootpath: string): Widget<Action<LoginState<a, ExtraUserInfo>>> => {
    let passwordInputType = s0.change_password_data.show_password ? "text" : "password"
    let old_password_error = (s0.status == "change password - error missing fields") || (s0.status == "change password - error incorrect password");
    let new_password_error = (s0.status == "change password - error too weak password");
    let new_password_confirmed_error = (s0.change_password_data.new_password_confirmed != undefined && s0.change_password_data.new_password != s0.change_password_data.new_password_confirmed);

    return mk_widget({
      run: (setState: (_: Action<LoginState<a, ExtraUserInfo>>) => void) => {
        return (
          <section className={getClassName(options, "block_classname", "container")} key="login-widget-change-password-form">
            <header className={getClassName(options, "header_classname", "mb-4")}>
              <Link className="header__link" to={`${rootpath}`}>
                <h1 className={getClassName(options, "title_classname", "mb-4")}>{i18next.t(`loginflow:change_password.title`)}</h1>
                <svg className="header__logo" width="120" height="32" aria-hidden="true">
                  <use xlinkHref="#icon--logo" />
                </svg>
              </Link>
            </header>

            <div className={getClassName(options, "inner_classname", "py-5")}>
              <form onSubmit={(e) => handleSubmit(e, setState)} className={getClassName(options, "form_classname", "")}>
                <div className={getClassName(options, "form_inner_classname", "")}>

                  <div className={getClassName(options, "form_group_classname", "form-group")}>
                    <label
                      htmlFor="old_password"
                      className={getClassName(options, "form_label_classname", "")}
                    >
                      {i18next.t(`loginflow:change_password.fields.old_password`)}
                    </label>
                    <input
                      type={passwordInputType}
                      name="old_password"
                      id="old_password"
                      aria-invalid={old_password_error}
                      aria-describedby={old_password_error ? "a11y-old-password-error" : null}
                      className={getClassName(options, "form_input_password_classname", `form-control ${old_password_error ? "is-invalid" : ""}`)}
                      value={s0.change_password_data.old_password || ""}
                      disabled={readonly}
                      onChange={(event) => setState(s => isChangePasswordState(s) ? ({
                        ...s,
                        status: "change password",
                        change_password_data: {
                          ...s.change_password_data,
                          old_password: event.currentTarget.value
                        }
                      }) : s)
                      }
                    />
                    {/* Password toggle */}
                    <div className="form__password-toggle">                    
                      <input
                        type="checkbox"
                        name="show_password"
                        id="show_password1"
                        className={getClassName(options, "form_checkbox_classname", "form-check-input")}
                        checked={s0.change_password_data.show_password}
                        disabled={readonly}
                        tabIndex={-1}
                        onChange={(event) => setState(s => isChangePasswordState(s) ? ({
                          ...s,
                          status: "change password",
                          change_password_data: {
                            ...s.change_password_data,
                            show_password: event.target.checked
                          }
                        }) : s)}
                      />
                      <label htmlFor="show_password1">
                        <span className="sr-text">{i18next.t(`loginflow:change_password.fields.show_password_checkbox`)}</span>
                        <svg className="form__password-icon form__password-icon--on" aria-hidden="true">
                          <use xlinkHref="#icon--eye" />
                        </svg>
                        <svg className="form__password-icon form__password-icon--off" aria-hidden="true">
                          <use xlinkHref="#icon--eye-off" />
                        </svg>
                      </label>
                    </div>

                    {old_password_error && (
                      <p id="a11y-old-password-error" className={getClassName(options, "form_input_error_classname", "invalid-feedback d-block")}>
                        {i18next.t(`loginflow:change_password.fields.old_password_invalid`)}
                      </p>
                    )}
                  </div>

                  <div className={getClassName(options, "form_group_classname", "form-group")}>
                    <label
                      htmlFor="new_password"
                      className={getClassName(options, "form_label_classname", "")}
                    >
                      {i18next.t(`loginflow:change_password.fields.new_password`)}
                    </label>
                    <input
                      type={passwordInputType}
                      name="new_password"
                      id="new_password"
                      aria-invalid={new_password_error}
                      aria-describedby={new_password_error ? "a11y-new-password-error" : null}
                      className={getClassName(options, "form_input_password_classname", `form-control ${new_password_error ? "is-invalid" : ""}`)}
                      value={s0.change_password_data.new_password || ""}
                      disabled={readonly}
                      onChange={(event) => setState(s => isChangePasswordState(s) ? ({
                        ...s,
                        status: "change password",
                        change_password_data: {
                          ...s.change_password_data,
                          new_password: event.currentTarget.value
                        }
                      }) : s)
                      }
                    />
                    {/* Password toggle */}
                    <div className="form__password-toggle">                    
                      <input
                        type="checkbox"
                        name="show_password"
                        id="show_password2"
                        className={getClassName(options, "form_checkbox_classname", "form-check-input")}
                        checked={s0.change_password_data.show_password}
                        disabled={readonly}
                        tabIndex={-1}
                        onChange={(event) => setState(s => isChangePasswordState(s) ? ({
                          ...s,
                          status: "change password",
                          change_password_data: {
                            ...s.change_password_data,
                            show_password: event.target.checked
                          }
                        }) : s)}
                      />
                      <label htmlFor="show_password2">
                        <span className="sr-text">{i18next.t(`loginflow:change_password.fields.show_password_checkbox`)}</span>
                        <svg className="form__password-icon form__password-icon--on" aria-hidden="true">
                          <use xlinkHref="#icon--eye" />
                        </svg>
                        <svg className="form__password-icon form__password-icon--off" aria-hidden="true">
                          <use xlinkHref="#icon--eye-off" />
                        </svg>
                      </label>
                    </div>
                  </div>

                  <div className={getClassName(options, "form_group_classname", "form-group")}>
                    <label
                      htmlFor="new_password_confirmed"
                      className={getClassName(options, "form_label_classname", "")}
                    >
                      {i18next.t(`loginflow:change_password.fields.new_password_confirmed`)}
                    </label>
                    <input
                      type={passwordInputType}
                      name="new_password_confirmed"
                      id="new_password_confirmed"
                      aria-invalid={new_password_confirmed_error}
                      aria-describedby={new_password_confirmed_error ? "a11y-new-password-confirmed-error" : null}
                      className={getClassName(options, "form_input_password_classname", `form-control ${new_password_confirmed_error ? "is-invalid" : ""}`)}
                      value={s0.change_password_data.new_password_confirmed || ""}
                      disabled={readonly}
                      onChange={(event) => setState(s => isChangePasswordState(s) ? ({
                        ...s,
                        status: "change password",
                        change_password_data: {
                          ...s.change_password_data,
                          new_password_confirmed: event.currentTarget.value
                        }
                      }) : s)
                      }
                    />
                    {/* Password toggle */}
                    <div className="form__password-toggle">                    
                      <input
                        type="checkbox"
                        name="show_password"
                        id="show_password3"
                        className={getClassName(options, "form_checkbox_classname", "form-check-input")}
                        checked={s0.change_password_data.show_password}
                        disabled={readonly}
                        tabIndex={-1}
                        onChange={(event) => setState(s => isChangePasswordState(s) ? ({
                          ...s,
                          status: "change password",
                          change_password_data: {
                            ...s.change_password_data,
                            show_password: event.target.checked
                          }
                        }) : s)}
                      />
                      <label htmlFor="show_password3">
                        <span className="sr-text">{i18next.t(`loginflow:change_password.fields.show_password_checkbox`)}</span>
                        <svg className="form__password-icon form__password-icon--on" aria-hidden="true">
                          <use xlinkHref="#icon--eye" />
                        </svg>
                        <svg className="form__password-icon form__password-icon--off" aria-hidden="true">
                          <use xlinkHref="#icon--eye-off" />
                        </svg>
                      </label>
                    </div>

                    {new_password_confirmed_error && (
                      <p id="a11y-new-password-confirmed-error" className={getClassName(options, "form_input_error_classname", "invalid-feedback d-block")}>
                        {i18next.t(`loginflow:change_password.fields.new_password_confirmed_invalid`)}
                      </p>
                    )}
                  </div>

                  {notifications(s0, { style: LoginFlowClasses }).run(() => s => s)}

                  <p className={getClassName(options, "form_description_classname", "lead")}>{i18next.t(`loginflow:change_password.text`)}</p>

                  <div className={getClassName(options, "form_actions_classname", "")}>
                    <button
                      type="submit"
                      className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                      disabled={readonly}
                    >
                      {i18next.t(`loginflow:change_password.clickables.submit`)}
                    </button>

                    <footer className={getClassName(options, "footer_classname", "")}>
                      {data.without_browserRouter
                        ? <button
                          type="button"
                          className={getClassName(options, "clickable_secondary_classname", "btn btn-link border-0 ml-1 p-0")}
                          onClick={() => setState(update_state_with_route<a, ExtraUserInfo>({ kind: "home" }, data))}
                        >
                          {i18next.t(`loginflow:change_password.clickables.cancel`)}
                        </button>
                        : <Link
                          to={`${rootpath}/`}
                          className={getClassName(options, "clickable_secondary_classname", "btn btn-link")}
                        >
                          {i18next.t(`loginflow:change_password.clickables.cancel`)}
                        </Link>
                      }
                    </footer>
                  </div>
                </div>
              </form>
            </div>
          </section>
        )
      }
    })
  }
}

export function change_password_success<a>(
  data: MinimalLoginWidgetData<a, ExtraUserInfo>,
  options?: { style?: LoginFlowStyle; key?: string }
) {
  return (s0: ChangePasswordState<ExtraUserInfo>, rootpath: string): Widget<Action<LoginState<a, ExtraUserInfo>>> => {
    return mk_widget({
      run: (setState: (_: Action<LoginState<a, ExtraUserInfo>>) => void) => {
        return (
          <section className={getClassName(options, "block_classname", "container")} key="login-widget-change-password-success">
            <header className={getClassName(options, "header_classname", "mb-4")}>
              <Link className="header__link" to={`${rootpath}`}>
                <h1 className={getClassName(options, "title_classname", "mb-4")}>{i18next.t(`loginflow:change_password_success.title`)}</h1>
                <svg className="header__logo" width="120" height="32" aria-hidden="true">
                  <use xlinkHref="#icon--logo" />
                </svg>
              </Link>
            </header>

            <div className={getClassName(options, "inner_classname", "py-5")}>
              <div className={getClassName(options, "form_classname", "")}>
                <div className={getClassName(options, "form_inner_classname", "")}>
                  <p className={getClassName(options, "intro_classname", "lead")}>{i18next.t(`loginflow:change_password_success.text`)}</p>
                  <footer className={getClassName(options, "form_actions_classname", "")}>
                    {data.without_browserRouter
                      ? <button
                          type="button"
                          className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                          onClick={() => setState(update_state_with_route({ kind: "home" }, data))}
                        >
                          {i18next.t(`loginflow:change_password_success.clickables.submit`)}
                        </button>
                      : <Link
                          to={`${rootpath}/`}
                          className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                        >
                          {i18next.t(`loginflow:change_password_success.clickables.submit`)}
                        </Link>
                    }
                  </footer>
                </div>
              </div>
            </div>
          </section>
        )
      }
    })
  }
}